




























import { Component, Vue } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import { validTel } from "@/shared/validators";
import { ConsultoresService } from "@/services/consultores.service";
import Confirm from "@/shared/components/confirm.vue";

@Component({
  components: {
    Modal,
    Confirm,
  },
})
export default class AlterarTelefone extends Vue {
  idConsultor!: number;
  tipoNumeroTelefone!: number;
  numeroTelefone: string | null = null;
  loading = false;
  tituloManter = "";

  rules = {
    numeroTelefone: [validTel()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarTelefone(
    idConsultor: number,
    tipoNumeroTelefone: number,
    numeroTelefone: string
  ) {
    this.idConsultor = Number(idConsultor);
    this.tipoNumeroTelefone = tipoNumeroTelefone;
    if (
      numeroTelefone == "0" ||
      numeroTelefone == " " ||
      numeroTelefone == undefined ||
      numeroTelefone == "null"
    ) {
      this.numeroTelefone = "";
    } else {
      this.numeroTelefone = numeroTelefone;
    }
    this.setTitulo();
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    return p;
  }

  async alterarTelefone() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;
    let res = true;

    if (form.validate()) {
      if (!this.numeroTelefone) {
        const modalConfirm = this.$refs.confirm as Confirm;
        const title = "Alerta de campo vazio";
        const text = "Deseja realmente deixar o número de contato vazio?";
        res = await modalConfirm.open(title, text);
      }
      if (res) {
        const numeroTelefoneFormatado = this.numeroTelefone!.replace(
          /([^\d])+/gim,
          ""
        );
        this.loading = true;
        try {
          await ConsultoresService.AlterarNumeroContato(
            this.idConsultor,
            numeroTelefoneFormatado,
            this.tipoNumeroTelefone
          );
          this.loading = false;
        } finally {
          this.loading = false;
        }
        return modal.close(true);
      }
    }
  }

  setTitulo() {
    if (this.tipoNumeroTelefone == 1) {
      this.tituloManter = "Alterar Telefone";
    } else {
      this.tituloManter = "Alterar Celular";
    }
  }
}
